import { Moment } from 'moment';
import { ActionOrdersFilter } from '../enum/actionOrdersFilter';
import { DateShortFilter } from '../enum/dateShortFilter';
import { OrderStatus } from '../enum/orderStatus';

export class OrderFilter {
  shortFilter: DateShortFilter;
  actionOrders: ActionOrdersFilter;
  statuses: OrderStatus[];
  startDate: Moment;
  untilDate: Moment;
  isDashboardOrder: boolean;

  constructor() {
    this.actionOrders = null;
    this.shortFilter = DateShortFilter.ThisWeek;
    this.statuses = [];
    this.startDate = null;
    this.untilDate = null;
    this.isDashboardOrder = false;
  }
}
